import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/webforyou.svg';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-12 mt-auto">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <img src={logo} alt="WebForYou Support" className="h-8 w-auto" />
            <p className="text-sm">
              Segítünk vállalkozásának az online térben való megjelenésben a NEUM pályázat keretein belül.
            </p>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Gyors linkek</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-purple-400 transition-colors">
                  Kezdőlap
                </Link>
              </li>
              <li>
                <Link to="/tudnivalok" className="text-sm hover:text-purple-400 transition-colors">
                  Tudnivalók
                </Link>
              </li>
              <li>
                <Link to="/adatvedelem" className="text-sm hover:text-purple-400 transition-colors">
                  Adatvédelem
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Kapcsolat</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center space-x-2">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:nagyroland@webforyou.hu" className="hover:text-purple-400 transition-colors">
                  nagyroland@webforyou.hu
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a href="tel:+36709083086" className="hover:text-purple-400 transition-colors">
                  +36 70 908 3086
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Pályázati információ</h3>
            <p className="text-sm mb-4">
              A "Minden vállalkozásnak legyen saját honlapja" Program keretében akár 1.100.000 Ft vissza nem térítendő támogatás igényelhető.
            </p>
            <a 
              href="https://forms.gle/mfDWN7v71sycLqbz8"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block text-sm text-purple-400 hover:text-purple-300 transition-colors"
            >
              Jelentkezés a pályázatra →
            </a>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-sm text-center">
          <p>
            © 2025 Webforyou Kft. Minden jog fenntartva.
          </p>
          <p className="mt-2 text-gray-500">
            A weboldal a NEUM program elősegítése céljából készült.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 